import {SanityBlockTeamMembers} from '~/types/sanityTypes';
import {TeamMemberCard} from '~/components';

export function BlockTeamMembers({
  blockContent,
}: {
  blockContent: SanityBlockTeamMembers;
}) {
  return (
    <>
      <div className="block-team-members">
        <div className="container">
          <div className="grid py-6 md:py-12">
            <div className="grid items-start grid-cols-2 gap-4 lg:grid-cols-3 lg:gap-6 xl:grid-cols-4">
              {blockContent.teamMembers.map((item) => (
                <TeamMemberCard key={item._id} teamMember={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
